import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {AdminIntegrationSource} from 'sources/admin/integration/AdminIntegrationSource';

class AdminAccountIntegrationActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchAdminAccountIntegrations'));
  }

  /**
   * Callback triggered when loading the account integrations from the backend.
   * Sends a request to the backend to retrieve all the integrations
   */
  fetchAdminAccountIntegrations() {
    return dispatch => {
      dispatch();
      return AdminIntegrationSource.retrieve().then(
        this.fetchAdminAccountIntegrationsSuccess,
        this.fetchAdminAccountIntegrationsError
      );
    };
  }
}

export default alt.createActions(AdminAccountIntegrationActions);
